<template>
  <div class="invite-view overflow-hidden">
    <div
      class="background"
      :style="{ backgroundImage: `url(${invite.background})` }"
      v-if="invite.background"
    >
      <div class="logo-wrapper">
        <img :src="invite.logo" class="logo" />
      </div>
    </div>

    <b-container>
      <b-row class="d-flex flex-column flex-lg-column-reverse flex-xl-row">
        <b-col cols="12" xl="4">
          <div class="d-flex justify-content-center">
            <div class="d-flex flex-column align-items-center">
              <div
                class="d-inline-block justify-content-center align-items-center"
              >
                <div
                  class="status d-flex align-items-center font-weight-bold"
                  :class="
                    invite.status +
                      (invite.status !== 'ongoing' ? 'invisible' : '')
                  "
                >
                  REMAINING:
                </div>
              </div>
              <h1 class="date d-inline-block text-capitalize">
                {{ getDate(invite) }}
              </h1>
              <div class="social d-inline-flex">
                <b-btn
                  class="mr-1"
                  variant="link"
                  @click="subscribe(invite)"
                  style="width: 30px;"
                >
                  <font-awesome-icon
                    icon="heart"
                    size="2x"
                    color="red"
                    v-if="invite.subscription"
                  />
                  <font-awesome-icon
                    :icon="['far', 'heart']"
                    size="2x"
                    color="black"
                    v-else
                  />
                </b-btn>
                <social name="invite" :target="invite" black></social>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" xl="8">
          <div class="application">
            <div class="d-flex flex-column flex-lg-row">
              <div class="information">
                <div class="title">
                  {{ invite.title }}
                </div>
                <div class="subtitle">
                  {{ invite.subtitle }}
                  <hr />
                </div>
                <div class="description">
                  {{ invite.description }}
                </div>
              </div>

              <div class="apply my-3 my-lg-0">
                <b-btn
                  :to="`/goodluck/${invite.id}/upload/`"
                  class="application-button"
                  :disabled="invite.status !== 'ongoing'"
                >
                  {{ getApplicationText(invite) }}
                </b-btn>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="sticky" ref="sticky">
      <b-container fluid>
        <hr />
      </b-container>
      <b-container>
        <div
          class="d-flex flex-row-reverse justify-content-end justify-content-lg-center justify-content-xl-end"
          style="margin-top: -30px;"
        >
          <b-button
            class="menu"
            :class="{ active: tabIndex === 2 }"
            @click="setTab(2)"
            v-if="invite.id && (invite.owner === user.id || user.is_staff)"
          >
            SUBMISSIONS
          </b-button>
          <b-button
            class="menu"
            :class="{ active: tabIndex === 1 }"
            @click="setTab(1)"
            v-if="invite.id && invite.status === 'selection'"
          >
            SELECTED
          </b-button>
          <b-button
            class="menu"
            :class="{ active: tabIndex === 0 }"
            @click="setTab(0)"
          >
            DETAIL
          </b-button>
        </div>
        <div>
          <b-btn
            :to="`/goodluck/${invite.id}/upload/`"
            class="hover-button d-none d-lg-block"
            :disabled="invite.status !== 'ongoing'"
          >
            {{ getApplicationText(invite) }}
          </b-btn>
        </div>
      </b-container>
    </div>

    <div class="menu-container" ref="menu">
      <b-container fluid>
        <hr />
      </b-container>
      <b-container>
        <div
          class="d-flex flex-row-reverse justify-content-end justify-content-lg-center justify-content-xl-end"
          style="margin-top: -30px;"
        >
          <b-button
            class="menu"
            :class="{ active: tabIndex === 2 }"
            @click="setTab(2)"
            v-if="invite.id && (invite.owner === user.id || user.is_staff)"
          >
            SUBMISSIONS
          </b-button>
          <b-button
            class="menu"
            :class="{ active: tabIndex === 1 }"
            @click="setTab(1)"
            v-if="invite.id && invite.status === 'selection'"
          >
            SELECTED
          </b-button>
          <b-button
            class="menu"
            :class="{ active: tabIndex === 0 }"
            @click="setTab(0)"
          >
            DETAIL
          </b-button>
        </div>
      </b-container>
    </div>

    <div class="page-container" v-if="tabIndex === 0">
      <div
        :key="pageNumber"
        class="page"
        v-for="(page, pageNumber) in invite.pages"
        v-if="invite.pages.length"
        :style="{ backgroundColor: page.background_color }"
      >
        <div v-if="user.is_staff">
          <b-button class="mr-1" size="sm">
            {{ pageNumber + 1 }}
          </b-button>
          <b-button class="mr-1" size="sm">
            {{ page.background_color }}
          </b-button>
          <b-button size="sm" @click="deletePage(pageNumber)">
            삭제하기
          </b-button>
        </div>
        <b-container>
          <b-row>
            <b-col
              :key="columnNumber"
              class="column"
              :lg="column.width"
              v-for="(column, columnNumber) in page.columns"
              v-if="page.columns.length"
            >
              <div v-if="column.editing">
                <html-editor
                  :id="`editor-${pageNumber}-${columnNumber}`"
                  v-model="column.content"
                  :backgroundColor="page.background_color"
                  @upload="upload(pageNumber, columnNumber, ...arguments)"
                  :ref="`editor-${pageNumber}-${columnNumber}`"
                >
                </html-editor>
                <div class="mt-1">
                  <b-button
                    class="mr-1"
                    @click="commit(pageNumber, columnNumber)"
                  >
                    저장하기
                  </b-button>
                  <b-button
                    class="mr-1"
                    @click="discard(pageNumber, columnNumber)"
                  >
                    취소하기
                  </b-button>
                  <b-button
                    @click="setWidth(pageNumber, columnNumber, 6)"
                    v-if="column.width === 12"
                  >
                    좁게
                  </b-button>
                  <b-button
                    @click="setWidth(pageNumber, columnNumber, 12)"
                    v-if="column.width === 6"
                  >
                    넓게
                  </b-button>
                </div>
              </div>
              <div v-else>
                <div class="my-1" v-if="user.is_staff">
                  <b-button class="mr-1" size="sm">
                    {{ columnNumber + 1 }}
                  </b-button>
                  <b-button
                    class="mr-1"
                    size="sm"
                    @click="edit(pageNumber, columnNumber)"
                  >
                    편집하기
                  </b-button>
                  <b-button
                    size="sm"
                    @click="deleteColumn(pageNumber, columnNumber)"
                  >
                    삭제하기
                  </b-button>
                </div>
                <div v-html="column.content"></div>
              </div>
            </b-col>
            <b-col
              class="d-flex justify-content-center align-items-center"
              cols="12"
              v-if="!page.columns.length"
            >
              내용이 없습니다.
            </b-col>
            <b-col
              class="d-flex justify-content-center mt-5"
              cols="12"
              v-if="user.is_staff"
            >
              <b-button size="sm">
                <font-awesome-icon icon="plus" @click="addColumn(pageNumber)" />
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-row v-else>
        <b-col
          class="d-flex justify-content-center align-items-center"
          style="height: 60vh;"
        >
          내용이 없습니다.
        </b-col>
      </b-row>
      <b-row v-if="user.is_staff">
        <b-col class="d-flex justify-content-center p-5" cols="12">
          <b-button size="sm">
            <font-awesome-icon icon="plus" @click="addPage" />
          </b-button>
        </b-col>
      </b-row>
    </div>

    <div v-if="tabIndex === 1">
      <artworks v-model="selected" :invite="invite" :selected="true" />
    </div>

    <div v-if="tabIndex === 2">
      <artworks v-model="submissions" :invite="invite" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import {
  Artwork,
  Invite,
  InvitePage,
  InviteColumn,
  InviteSubscription
} from "../models";
import Social from "../components/Social";
import HtmlEditor from "../components/HtmlEditor.vue";

export default {
  props: ["id"],
  components: {
    Social,
    HtmlEditor
  },
  data() {
    return {
      moment,
      user: window.user,
      invite: {
        pages: []
      },
      tabIndex: 0,
      selected: { results: [] },
      submissions: { results: [] }
    };
  },
  async created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    if (this.id) {
      this.invite = await new Invite({
        id: this.id
      }).load();
    }
  },
  methods: {
    async setTab(index) {
      this.tabIndex = index;

      if (index === 1) {
        if (
          this.invite.owner === this.user.id ||
          this.user.is_staff ||
          this.invite.status === "selection"
        ) {
          document.body.classList.add("loading-open");
          try {
            this.selected = await new Artwork().byInvite(this.id, {
              selected: true
            });
          } finally {
            document.body.classList.remove("loading-open");
          }
        }
      }

      if (index === 2) {
        if (this.invite.owner === this.user.id || this.user.is_staff) {
          document.body.classList.add("loading-open");
          try {
            this.submissions = await new Artwork().byInvite(this.id);
          } finally {
            document.body.classList.remove("loading-open");
          }
        }
      }
    },
    getDate(invite) {
      this.moment.locale("en");

      switch (invite.status) {
        case "ongoing":
          return this.moment(invite.closed).fromNow(true);
        case "examination":
          return "00:00:00";
        case "selection":
          return moment(invite.selected).format("YYYY.MM.DD");
      }

      return "";
    },
    getStatus(invite) {
      switch (invite.status) {
        case "review":
          return "Under review (검토중)";
      }
    },
    getApplicationText(invite) {
      switch (invite.status) {
        case "ongoing":
          return "지원하기";
        case "examination":
          return "심사중";
      }

      return "마감";
    },
    async addPage() {
      let order = 1;
      if (this.invite.pages.length) {
        order = this.invite.pages[this.invite.pages.length - 1].order + 1;
      }

      const page = new InvitePage({
        invite: this.invite.id,
        background_color: "#FFFFFF",
        order,
        columns: []
      });
      await page.save();

      this.invite.pages.push(page);
    },
    async deletePage(pageNumber) {
      const page = this.invite.pages[pageNumber];
      if (page.id) {
        await new InvitePage(page).delete();
      }

      this.invite.pages.splice(pageNumber, 1);
    },
    async addColumn(pageNumber) {
      const page = this.invite.pages[pageNumber];
      let order = 1;
      if (page.columns.length) {
        order = page.columns[page.columns.length - 1].order + 1;
      }

      const column = await new InviteColumn({
        page: page.id,
        content: "",
        width: 6,
        order
      }).save();
      column.editing = true;

      page.columns.push(column);
    },
    async deleteColumn(pageNumber, columnNumber) {
      const column = this.invite.pages[pageNumber].columns[columnNumber];
      if (column.id) {
        await new InviteColumn(column).delete();
      }

      this.invite.pages[pageNumber].columns.splice(columnNumber, 1);
    },
    edit(pageNumber, columnNumber) {
      const column = this.invite.pages[pageNumber].columns[columnNumber];

      column._content = column.content;
      column._width = column.width;
      this.$set(column, "editing", true);
    },
    async commit(pageNumber, columnNumber) {
      document.body.classList.add("loading-open");
      try {
        await this.$refs[`editor-${pageNumber}-${columnNumber}`][0].save();

        const column = this.invite.pages[pageNumber].columns[columnNumber];
        await new InviteColumn(column).save();

        this.$set(column, "editing", false);
      } finally {
        document.body.classList.remove("loading-open");
      }
    },
    async discard(pageNumber, columnNumber) {
      const column = this.invite.pages[pageNumber].columns[columnNumber];
      if (!column.id) {
        await this.deleteColumn(pageNumber, columnNumber);
        return;
      }

      column.content = column._content;
      column.width = column._width;
      this.$set(column, "editing", false);
    },
    async setWidth(pageNumber, columnNumber, width) {
      const column = this.invite.pages[pageNumber].columns[columnNumber];
      column.width = width;
    },
    async upload(pageNumber, columnNumber, filename, blob, success, failure) {
      const column = this.invite.pages[pageNumber].columns[columnNumber];

      try {
        const presigned = await new InviteColumn(column).presign(blob, {
          filename,
          type: blob.type
        });

        await axios.put(presigned.url, blob, {
          headers: {
            "Content-Type": blob.type,
            "x-amz-acl": "public-read"
          }
        });

        success(presigned.filename);
      } catch (e) {
        document.body.classList.remove("loading-open");
        failure();
      }
    },
    handleScroll() {
      let offset = 15;

      const block = document.getElementsByClassName("d-lg-block")[0];
      if (block.clientHeight) {
        offset = 75;
      }

      if (window.pageYOffset + offset > this.$refs.menu.offsetTop) {
        this.$refs.sticky.classList.add("show");
      } else {
        this.$refs.sticky.classList.remove("show");
      }
    },
    async subscribe(invite) {
      // window.user is {} when signed out, so check for an id.
      if (!this.user.id) {
        this.$router.push({
          name: "login",
          query: {
            redirect: this.$route.fullPath
          }
        });
        return;
      }

      if (invite.subscription) {
        await new InviteSubscription({
          id: invite.subscription
        }).delete();

        this.$set(invite, "subscription", null);
      } else {
        const { id } = await new InviteSubscription({
          invite: invite.id
        }).save();

        this.$set(invite, "subscription", id);
      }
    }
  }
};
</script>

<style lang="scss">
// Target v-html content, which scoped CSS can't reach.
.invite-view .no-padding {
  max-width: 100%;
  margin: 0 !important;
}

.invite-view .page .container .row {
  margin-left: -15px;
  margin-right: -15px;
}
</style>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid.scss";

.background {
  display: flex;
  align-items: center;
  height: 520px;
  background-size: cover;
  background-position: center;
}

.logo-wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @include media-breakpoint-up(lg) {
    width: 520px;
    margin-top: 0;
    padding-left: 40px;
  }

  .logo {
    max-width: 240px;
  }
}

.status {
  margin-right: 10px;
  margin-top: 30px;

  @include media-breakpoint-up(lg) {
    margin-top: 24px;
  }

  &:before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: red;
    margin-right: 5px;
  }
}

.status.ongoing:before {
  background-color: #00ff00;
}

.status.examination.before {
  background-color: #fff000;
}

@font-face {
  font-family: "pixpills b";
  src: url("/static/pixpills-b.woff") format("woff");
}

.date {
  font-family: pixpills b;
  font-size: 60px;
}

.social {
  margin-top: 30px;
  margin-bottom: 30px;

  @include media-breakpoint-up(lg) {
    margin-top: inherit;
    margin-bottom: inherit;
  }
}

.invite-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -250px;
}

.application {
  overflow: hidden;
  background-color: white;

  @include media-breakpoint-up(lg) {
    height: 300px;
    margin-top: -100px;
    border: solid 1px #e3e3e3;
    border-radius: 150px;
  }

  .information {
    display: flex;
    flex-direction: column;
    text-align: center;

    @include media-breakpoint-up(lg) {
      height: 300px;
      padding: 30px 0 30px 100px;
      border-radius: 150px 0 0 150px;
      text-align: left;
    }
  }

  .apply {
    @include media-breakpoint-up(lg) {
      margin-top: -1px;
      min-width: 300px;
      padding: 1px 3px 3px 1px;
    }

    .application-button {
      width: 100%;
      height: 120px;
      margin-right: 0;
      border-radius: 60px;
      background-color: white;
      color: black !important;
      font-size: 30px;

      &:focus {
        box-shadow: none !important;
      }

      @include media-breakpoint-up(lg) {
        min-width: 100%;
        height: 100%;
        margin: -1px;
        padding: 0;
        border: none;
        border-radius: 50%;
      }

      &:hover {
        background-color: #bf0018;
        color: white !important;
      }
    }

    a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
}

.subtitle {
  font-size: 13px;
  font-weight: bold;
}

.description {
  overflow-y: auto;
  text-align: left;
}

.badge.badge-pill {
  &.review {
    background-color: red;
  }
}

.page-container {
  margin-top: 60px;
}

.page {
  padding: 10px;

  @include media-breakpoint-up(lg) {
    padding: 35px;
  }
}

.column {
  padding: 15px;
}

.empty-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.menu-container {
  margin-top: 60px;
  margin-bottom: 45px;
}

.menu {
  margin-right: -10px;
  padding-left: 30px;
  padding-right: 30px;
  background-color: white;
  color: black !important;

  &.active {
    background-color: black !important;
    color: white !important;
  }
}

.sticky {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 15px;
  z-index: 1000;
  background-color: white;

  @include media-breakpoint-up(lg) {
    top: 60px;
  }

  &.show {
    display: block;
  }

  .hover-button {
    float: right;
    height: 100px;
    width: 100px;
    border-radius: 50px;
    margin-top: -30px;
    background-color: white;
    color: black !important;
    line-height: 90px;

    &:hover {
      background-color: #bf0018;
      color: white !important;
    }
  }
}
</style>
